import { Component, OnInit } from '@angular/core';
import { ConfigurationRCSModel } from 'src/app/models/configuration';
import { AnnotationService } from 'src/app/services/annotation.service';
import { CalculationsService } from 'src/app/services/calculations.service';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { PointsService } from 'src/app/services/points.service';



@Component({
    selector: 'app-coordenates-control',
    templateUrl: './coordenates-control.component.html',
    styleUrls: ['./coordenates-control.component.scss'],
    standalone: false
  })

  export class CoordenatesControlComponent implements OnInit {
    active:boolean = false;
    coordenatesController: CoordenateService;

    constructor(coordenatesController : CoordenateService,
      private pointService : PointsService,
      private calculationsService: CalculationsService,
      private annotationService: AnnotationService){
      this.coordenatesController = coordenatesController;
    }

    ngOnInit(): void {

    }

    coordenatesTrigger(): void{
      this.active = !this.active;
    }


    activateRCS(rcs: ConfigurationRCSModel): void{
      if(!rcs.isactive){
        this.coordenatesController.setRCSActive(rcs);
        this.pointService.reprojectMap(rcs.epsg);
        //this.annotationService.reprojectAnnotations(rcs.epsg);
        this.calculationsService.reprojectCalculations(rcs.epsg);
      }
    }

  }




